import { BottomTabNavigationOptions, createBottomTabNavigator } from '@react-navigation/bottom-tabs'
import { Center } from 'native-base'
import React, { FC } from 'react'

import { HistoryStack } from './HistoryStack'
import { OffersStack } from './OffersStack'
import { UserStack } from './UserStack'
import { getNavigationTabIconName } from './helpers'

import { Icon } from '~components/Icon'
import { useCallback, useNavigationTheme, useTranslation } from '~hooks'
import { Routes } from '~types/routesNames'

const { Navigator, Screen } = createBottomTabNavigator<MainTabParamList>()

type ScreenOptions = (params: BottomTabScreenProps) => BottomTabNavigationOptions

export const BottomTabNavigator: FC = () => {
  const { t } = useTranslation()

  const { tabBarTheme } = useNavigationTheme()

  const screenOptions = useCallback<ScreenOptions>(
    ({ route }) => ({
      tabBarIcon: ({ size, focused }) => {
        return (
          <Center w={size + 10} h={size + 10} borderRadius="lg" color="actionBlue">
            <Icon
              name={getNavigationTabIconName({ routeName: route.name, focused })}
              size={size}
              color={focused ? 'actionBlue' : 'offMain'}
            />
          </Center>
        )
      },
      headerShown: false,
      ...tabBarTheme,
    }),
    [tabBarTheme]
  )

  return (
    <Navigator screenOptions={screenOptions}>
      <Screen
        name={Routes.OffersStack}
        options={{ title: t('navigation.screen_titles.offers_stack') }}
        component={OffersStack}
      />
      <Screen
        name={Routes.HistoryStack}
        options={{ title: t('navigation.screen_titles.history_stack') }}
        component={HistoryStack}
      />
      <Screen
        name={Routes.UserStack}
        options={{ title: t('navigation.screen_titles.user_stack') }}
        component={UserStack}
      />
    </Navigator>
  )
}
